"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const react_router_dom_1 = require("react-router-dom");
const ScrollToTopOnUpdate = ({ children }) => {
    const location = (0, react_router_dom_1.useLocation)();
    const [url, setUrl] = react_1.default.useState(location && location.pathname);
    react_1.default.useEffect(() => {
        if (!(location && location.pathname))
            return;
        if (location.pathname !== url) {
            window_or_global_1.default.scrollTo(0, 0);
            setUrl(location.pathname);
        }
    }, [location, url]);
    return children;
};
exports.default = ScrollToTopOnUpdate;
//# sourceMappingURL=ScrollToTopOnUpdate.js.map